import "../styles/Amenities.css"
import gym from "../assets/images/A_Gym.jpg"
import pool from "../assets/images/A_swimming-pool.jpg"
import yoga from "../assets/images/A_yoga.jpg"
import garden from "../assets/images/A_garden.jpg"
import track from "../assets/images/A_track.jpg"
import camera from "../assets/images/A_cameras.jpg"

export default function Amenities() {
  const amenities = [
    {
      id: 1,
      name: "Gym",
      image: `${gym}`,
    },
    {
      id: 2,
      name: "Swimming Pool",
      image: `${pool}`,
    },
    {
      id: 3,
      name: "Meditation",
      image: `${yoga}`,
    },
    {
      id: 4,
      name: "Garden",
      image: `${garden}`,
    },
    {
      id: 5,
      name: "Jogging Track",
      image: `${track}`,
    },
    {
      id: 6,
      name: "24x7 Security",
      image: `${camera}`,
    },
  ]

  return (
    <section id="amenities" className="amenities">
      <h3 className="section-label">AMENITIES</h3>
      <h2 className="section-title">Top-Tier Amenities Unveiled</h2>

      <div className="amenities-grid">
        {amenities.map((amenity) => (
          <div key={amenity.id} className="amenity-card">
            <img src={amenity.image || "/placeholder.svg"} alt={amenity.name} />
            <div className="amenity-label">{amenity.name}</div>
          </div>
        ))}
      </div>
    </section>
  )
}
